import { createGlobalStyle } from "styled-components";

const GlobalStyle: any = createGlobalStyle`
  img {
    max-width: 100%;
  }
  .ReactModal__Overlay {
    opacity: 0;
    transition: opacity .35s linear;
  }
  .ReactModal__Overlay--after-open{
    opacity: 1;
  }
  .ReactModal__Overlay--before-close{
    opacity: 0;
  }
  .ReactModal__Content {
    padding: 0 !important;

  }
  .ReactModal__Content {
    transform: translateY(-20px);
    transition: all .3s linear;
  }
  .ReactModal__Content.ReactModal__Content--after-open {
    transform: translateY(0);
  }
  input {
    outline: none;
  }
`;

export default GlobalStyle;
